(function () {
  function iniciarFormularioProducto(seccion) {
    var form = seccion.querySelector('[data-tipo="agregar-al-carrito"]');
    var dataScript = seccion.querySelector('[data-variantes-producto]');
    if (!form || !dataScript) return;

    var variantes = JSON.parse(dataScript.textContent);
    var inputVariantId = form.querySelector('[data-variant-id-input]');
    var opciones = Array.prototype.slice.call(seccion.querySelectorAll('[data-option-index]'));
    var botonAgregar = seccion.querySelector('[data-boton-agregar]');
    var textoBoton = seccion.querySelector('[data-texto-boton]');
    var precioMontos = seccion.querySelector('[data-precio-montos]');
    var galeriaPrincipal = seccion.querySelector('[data-galeria-principal]');
    var miniaturas = seccion.querySelectorAll('[data-galeria-miniaturas] .galeria__miniatura');

    function obtenerSeleccionActual() {
      return opciones.map(function (grupo) {
        var marcado = grupo.querySelector('[data-opcion-input]:checked');
        return marcado ? marcado.value : null;
      });
    }

    function encontrarVariante(seleccion) {
      return variantes.filter(function (v) {
        return v.opciones.every(function (valor, i) { return valor === seleccion[i]; });
      })[0];
    }

    function mostrarMedia(mediaId) {
      if (!mediaId || !galeriaPrincipal) return;
      var item = galeriaPrincipal.querySelector('[data-media-id="' + mediaId + '"]');
      if (!item) return;
      galeriaPrincipal.querySelectorAll('.galeria__item').forEach(function (el) { el.hidden = true; });
      item.hidden = false;
      miniaturas.forEach(function (m) {
        m.classList.toggle('is-activa', m.getAttribute('data-media-id') === String(mediaId));
      });
    }

    function actualizarVista(variante) {
      if (!variante) return;

      inputVariantId.value = variante.id;

      if (precioMontos) {
        var html = '<span class="precio__actual">' + variante.precio_formateado + '</span>';
        if (variante.precio_anterior_formateado) {
          html += '<span class="precio__anterior">' + variante.precio_anterior_formateado + '</span>';
          html += '<span class="insignia-descuento">-' + variante.porcentaje_descuento + '%</span>';
        }
        precioMontos.innerHTML = html;
      }

      if (botonAgregar) {
        botonAgregar.disabled = !variante.disponible;
      }
      if (textoBoton) {
        textoBoton.textContent = variante.disponible
          ? (botonAgregar.getAttribute('data-texto-disponible') || textoBoton.textContent)
          : (botonAgregar.getAttribute('data-texto-agotado') || 'Agotado');
      }

      mostrarMedia(variante.media_id);
    }

    opciones.forEach(function (grupo) {
      grupo.addEventListener('change', function () {
        var seleccion = obtenerSeleccionActual();
        var variante = encontrarVariante(seleccion);
        actualizarVista(variante);
      });
    });

    miniaturas.forEach(function (miniatura) {
      miniatura.addEventListener('click', function () {
        mostrarMedia(miniatura.getAttribute('data-media-id'));
      });
    });

    if (botonAgregar && textoBoton && !botonAgregar.hasAttribute('data-texto-disponible')) {
      botonAgregar.setAttribute('data-texto-disponible', textoBoton.textContent.trim());
    }
  }

  function iniciarPruebaSocial(contenedor) {
    var nombreEl = contenedor.querySelector('[data-prueba-social-nombre]');
    var dataScript = contenedor.nextElementSibling;
    if (!nombreEl || !dataScript || !dataScript.hasAttribute('data-prueba-social-nombres')) return;

    var nombres = JSON.parse(dataScript.textContent).filter(function (n) { return n; });
    if (nombres.length < 2) return;

    var intervalo = parseInt(contenedor.getAttribute('data-intervalo'), 10) || 4000;
    var indice = 0;

    setInterval(function () {
      indice = (indice + 1) % nombres.length;
      nombreEl.style.opacity = '0';
      setTimeout(function () {
        nombreEl.textContent = nombres[indice];
        nombreEl.style.opacity = '1';
      }, 200);
    }, intervalo);
  }

  document.querySelectorAll('.producto-principal').forEach(iniciarFormularioProducto);
  document.querySelectorAll('[data-prueba-social]').forEach(iniciarPruebaSocial);
})();
